import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import { updatePlacementKeyValueById } from '@client/core/atoms/placements.js';
import {
  debugLog,
  type PlacementId,
  PlacementStatus
} from '@schibsted-nmp/advertising-shared';

/** Fired when an ad has been requested for the ad slot. */
export function onSlotRequested(event: googletag.events.SlotRequestedEvent) {
  const placementId = event.slot.getSlotElementId() as PlacementId;

  debugLog(
    `Google ad requested for placement: ${placementId} with slot`,
    event.slot
  );

  updatePlacementKeyValueById(placementId, 'creativeType', 'banner');
  updatePlacementKeyValueById(placementId, 'status', 'requested');
  updateMetricByKey(placementId, PlacementStatus.AdRequested);
}
